var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"download-table"},[_c('v-btn',{attrs:{"color":"teal lighten-3"},on:{"click":_vm.downloadExcel}},[_c('v-icon',{attrs:{"light":""}},[_vm._v("mdi-microsoft-excel")]),_vm._v(" Pathway scores ")],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }